export default "__VITE_ASSET__378e77af__"